import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppContent from './AppContent';
import { CredentialsProvider } from './contexts/CredentialsContext';

function App() {
  return (
    <CredentialsProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </CredentialsProvider>
  );
}

export default App;
